const n = (v) => Number(v) || 0;

// Inputs the formulas depend on; target = data-testid of the field to jump to
export function requiredFields(s, ageOnly = false) {
  const { d } = s;
  const spouseRet = d.retirement.includeSpouse === "Y";
  const needCpp = n(d.profile.retirementAge) >= 65;
  const ageLabel = ageOnly ? "age" : "date of birth or age";
  return [
    ["client", "profile-age", `Client ${ageLabel}`, s.age > 0],
    ["client", "profile-retirementAge", "Retirement age", n(d.profile.retirementAge) > 0],
    ["client", "profile-lifeExpectancy", "Life expectancy (above retirement age)", n(d.profile.lifeExpectancy) > n(d.profile.retirementAge)],
    ...(s.ins.hasSpouse || spouseRet ? [["client", "profile-spouse-age", `Spouse ${ageLabel}`, s.spouseAge > 0]] : []),
    ["financial", "financial-income-clientAnnual", "Client income", n(d.financial.income.clientAnnual) > 0],
    ["financial", "financial-income-clientTakeHome", "Client take-home pay / month", n(d.financial.income.clientTakeHome) > 0],
    ["financial", "panel-expenses", "Monthly expenses", s.exp.totalMonthly > 0],
    ...(needCpp ? [["investment", "retirement-cppMonthly", "CPP estimate", n(d.retirement.cppMonthly) > 0]] : []),
    ...(needCpp ? [["investment", "retirement-yearsInCanada", "Years in Canada (OAS)", n(d.retirement.yearsInCanada) > 0]] : []),
    ...(spouseRet ? [
      ["investment", "retirement-spouse-cppMonthly", "Spouse CPP estimate", n(d.retirement.spouse?.cppMonthly) > 0],
      ["investment", "retirement-spouse-yearsInCanada", "Spouse years in Canada", n(d.retirement.spouse?.yearsInCanada) > 0],
    ] : []),
  ].map(([tab, target, label, ok]) => ({ tab, target, label, ok }));
}

export const requiredState = (s, ageOnly = false) => {
  const list = requiredFields(s, ageOnly);
  const missing = list.filter((x) => !x.ok);
  return { all: new Set(list.map((x) => x.target)), missing: new Set(missing.map((x) => x.target)), list: missing };
};
